import { manageCookies } from "@/business/shared/session/infrastructure/utils/manageCookies";

export const removeDataMemoryService = {
  async execute(): Promise<void> {
    const date = new Date();
    const expirationTimeInMilliseconds = 60 * 60 * 1000;
    const localExpirationTime = date.getTime() - expirationTimeInMilliseconds;
    const dateExpire = new Date(localExpirationTime).toUTCString();

    await Promise.all([this.removeUser(dateExpire)]);
  },

  async removeUser(dateExpire: string): Promise<void> {
    manageCookies.remove("userAuth", dateExpire);
  },
};
